/** @module csi/widget/svg/_Color **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-style",
	"dijit/form/DropDownButton",
	"csi/locale",
	"../SvgColorPalette",
	"./_Plugin",
	"./util",
	"dojo/text!./resources/DropDownButton.html"
], function(declare,lang,domStyle,DropDownButton,locale,SvgColorPalette,_Plugin, util,template) {

	return declare([DropDownButton, _Plugin], {
		templateString: template,

		/**
		 * The styling of the widget makes the focusNode cover titleNode, so apply title to focusNode too
		 */
		postCreate: function() {
			this.dropDown = new SvgColorPalette({
				bSupportTransparent: true,
				onChange: lang.hitch(this, this.onChangeColor)
			});

			this.inherited(arguments);
		},

		/**
		 * Update plugin value and disabled status based on selected shapes and attributes
		 * @param  {Shape[]} shapes
		 * @param  {Object} shapeAttrs
		 * @param  {Object} textAttrs
		 * @return {Boolean}
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			const {
				cssStyle,
				dropDown,
				editor,
				pluginName,
				propertyKey,
			} = this;
			let value;
			if (shapes?.length) {
				if (pluginName === "textColor") {
					if (editor.isSelectCanvasMode()) {
						value = editor.canvasApp.selection.getCommonTextValue(shapes, cssStyle, true);
					} else {
						value = textAttrs[cssStyle] || "#000000";
					}
				} else {
					value = editor.canvasApp.selection.getCommonValue(shapes, propertyKey, true);
				}
				if (value === "none") {
					value = dropDown.TRANSPARENT;
				}
			}
			this.set("value", value, false); 
			this._updateIcon(value);
			return this.inherited(arguments);
		},

		/**
		 * Set color style
		 * @param  {String} color
		 */
		onColor: function(color) {
			if (this.bText) {
				this.editor.setTextStyle('color', color, true);
			} else {
				this.editor.setShapeProperty(util.shapeProperties.fillColor, color);
			}
		},

		/**
		 * Update current color and apply to shapes
		 * @param  {Object} value
		 */
		onChangeColor: function(value) {
			this._updateIcon(value);
			this.onColor(value);
		},

		/**
		 *  Need to translate "none" to background color of toolbar for icon color
		 * @param  {String} value
		 */
		_updateIcon: function(value) {
			domStyle.set(this.iconNode.nextSibling,{
				'background': (value === this.dropDown.TRANSPARENT) ? "#f3f3f3" : (value || "#000000"),
				'outline': (value === this.dropDown.TRANSPARENT) ? "1px solid #bababa" : "none"
			});
		}
	});
});
